module.exports = __webpack_public_path__ + "img/todo.607ad7ce.svg";